type ScheduleColorTemperatureConfig = {
	minValue?: number;
	maxValue?: number;
};

type ScheduleDeviceModeConfig = {
	color_temp?: false | ScheduleColorTemperatureConfig;
};

type ScheduleDeviceConfig = {
	modes?: Record<string, ScheduleDeviceModeConfig>;
};

export function getScheduleColorTemperatureRange(
	deviceConfig: ScheduleDeviceConfig | undefined,
	preferredModes: unknown[],
): [number, number] | '' {
	const modes = deviceConfig?.modes ?? {};
	const preferredMode = preferredModes.find(
		(mode): mode is string => typeof mode === 'string' && Boolean(modes[mode]),
	);
	const modeConfig = preferredMode ? modes[preferredMode] : Object.values(modes)[0];
	const colorTemperature = modeConfig?.color_temp;

	if (
		!colorTemperature ||
		typeof colorTemperature.minValue !== 'number' ||
		typeof colorTemperature.maxValue !== 'number'
	) {
		return '';
	}

	return [colorTemperature.minValue, colorTemperature.maxValue];
}
